module.exports = __webpack_public_path__ + "img/logo.dc59718f.png";